import { el } from "./dom";
import { iconLock } from "./icons";
import { showToast } from "./toast";
import type { CryptoWorkerClient } from "../lib/workerClient";
import { humanizeDecryptStringError } from "../lib/humanizeError";
import { renderSnippetTabs } from "./codeSnippets";

const DECRYPT_STRING_SNIPPETS = {
  sdk: `import { decryptData } from "secure-crypt-sdk";

const plaintext = await decryptData(ciphertext, myPrivateKey, myPublicKey);`,
  cli: `python -m cli.main decrypt-string \\
  --privkey my_private.key \\
  --in msg.enc --out -
# Passphrase prompted interactively; "--out -" prints to stdout.`,
};

function fromHex(hex: string): Uint8Array {
  const clean = hex.trim();
  const out = new Uint8Array(clean.length / 2);
  for (let i = 0; i < out.length; i++) out[i] = parseInt(clean.slice(i * 2, i * 2 + 2), 16);
  return out;
}

export function renderDecryptStringPanel(worker: CryptoWorkerClient): HTMLElement {
  const ciphertextInput = el("textarea", { id: "dec-str-ciphertext", rows: "4", class: "mono-field", placeholder: "Paste ciphertext (hex) here" }, []);
  const output = el("textarea", { id: "dec-str-output", rows: "4", readonly: "true", placeholder: "Plaintext appears here" }, []);
  const btn = el("button", { type: "button", class: "primary-btn" }, [iconLock(), "Decrypt string"]);

  btn.addEventListener("click", async () => {
    try {
      const ciphertext = fromHex(ciphertextInput.value);
      const { plaintext } = await worker.decryptString(ciphertext);
      output.value = new TextDecoder().decode(plaintext);
      showToast("Opened.", "success");
    } catch (e) {
      showToast(humanizeDecryptStringError(e), "error");
    }
  });

  return el("section", {}, [
    el("p", { class: "eyebrow" }, ["Strings · Decrypt"]),
    el("h2", {}, ["Open a sealed message"]),
    el("p", { class: "lede" }, [
      "Uses whichever private key is currently unlocked in the ", el("strong", {}, ["Generate keypair"]), " tab.",
    ]),
    el("p", { class: "section-label" }, ["Integration"]),
    renderSnippetTabs(DECRYPT_STRING_SNIPPETS),
    el("p", { class: "section-label" }, ["Try it live"]),
    el("div", { class: "card" }, [
      el("p", { class: "field-label" }, ["Ciphertext"]),
      ciphertextInput,
      el("div", { class: "actions" }, [btn]),
      el("p", { class: "field-label" }, ["Plaintext"]),
      output,
    ]),
  ]);
}
